.viewport {
  /* `--u` below is expressed in cqw, so the screen scales with this element's
   * inline size rather than 100vw — which would include the scrollbar. */
  container-type: inline-size;
  display: flow-root;
  width: 100%;
}

.screen {
  /* One design pixel. It stays 1:1 as long as there is room for the narrowest
   * screen; under that the whole composition scales down together rather than
   * reflowing or overflowing. */
  --u: min(1px, 100cqw / var(--screen-min-width));

  position: relative;

  /* The container stretches between the two widths and the two heights. What
   * absorbs the difference is the main column's automatic gaps, not the
   * sections — they keep the size Figma gives them. */
  width: clamp(
    calc(var(--screen-min-width) * var(--u)),
    100cqw,
    calc(var(--screen-max-width) * var(--u))
  );
  height: clamp(
    calc(var(--screen-min-height) * var(--u)),
    100dvh,
    calc(var(--screen-max-height) * var(--u))
  );

  margin-inline: auto;

  /* Figma's "Mobile Screen" frame: white, clips its content, no padding. */
  padding: 0;
  overflow: hidden;
  background: #fff;

  /* Figma rasterises text with greyscale antialiasing. Matching it keeps the
   * light-on-dark hero from rendering noticeably heavier than the design. */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
